import { createContext } from 'react';

// Whether the publish API rejected the banner for exceeding the Live banner threshold.
// Shared through context, not a step prop, so the wizard's `steps` array stays stable:
// MultiStepForm resets every step's validation whenever `steps` changes.
export const LiveBannerLimitContext = createContext(false);

// Used only while remote config is loading or does not provide live_banner_threshold
export const DEFAULT_LIVE_BANNER_THRESHOLD = 5;

/**
 * Reads the maximum number of Live banners from remote config.
 * @param {Object} remoteConfig - uiState.remoteConfig from Redux
 * @returns {number}
 */
export const getLiveBannerThreshold = (remoteConfig) => {
  const threshold = Number(remoteConfig?.live_banner_threshold);
  return Number.isFinite(threshold) && threshold > 0 ? threshold : DEFAULT_LIVE_BANNER_THRESHOLD;
};

/**
 * The API rejects a publish over the Live banner limit with a 400, the same status it uses for
 * field validation errors, e.g.
 * { status: 'Fail', message: 'Cannot set banner to Live state: live banner threshold of 5 would be exceeded' }
 * so only the message tells them apart.
 * @param {Object} error - error thrown by BannerService (axios error)
 * @returns {boolean}
 */
export const isLiveBannerLimitError = (error) => {
  if (error?.response?.status !== 400) return false;
  const message = error.response.data?.message;
  const text = Array.isArray(message) ? message.join(' ') : String(message || '');
  return /live banner threshold/i.test(text);
};

export const getLiveBannerLimitMessage = (threshold) =>
  `You’ve reached the maximum limit of ${threshold} live banners. To publish this banner, please unpublish an existing live banner first. You can save this banner as a draft and publish it later.`;
